module.exports = __webpack_public_path__ + "static/media/NYAC.4d4c833f.png";